import { IndekseringLogg } from '../../../models';
import RequestService from '../requestService';
import { client } from '../../client';
export default class IndekseringLoggService extends RequestService<IndekseringLogg, 'indekseringLogg'> {
    StartIndeksering = async (id: number, indekseringType: string) => {
        return await client.post<IndekseringLogg>(`${this.serviceName}/${(id)}/${indekseringType}/StartIndeksering`, null);
    };
    KansellerIndeksering = async (id: number) => {
        return await client.post<string>(`${this.serviceName}/${(id)}/KansellerIndeksering`, null);
    };
}